import React from 'react';

const Insta = props => (
  <svg
    id="insta1"
    style={{ enableBackground: 'new 0 0 74 74' }}
    version="1.1"
    viewBox="0 0 74 74"
    x="0px"
    y="0px"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M59.5,74h-45C6.5,74,0,67.5,0,59.5v-45C0,6.5,6.5,0,14.5,0h45C67.5,0,74,6.5,74,14.5v45C74,67.5,67.5,74,59.5,74z&#xA;&#x9; M21.3,37.5c0,9.8,7.9,17.8,17.8,17.8s17.8-7.9,17.8-17.8S48.8,19.8,39,19.8S21.3,27.7,21.3,37.5z M10,14.5c0,3.3,2.7,6,6,6&#xA;&#x9;s6-2.7,6-6s-2.7-6-6-6S10,11.2,10,14.5z" />
  </svg>
);

export default Insta;



// WEBPACK FOOTER //
// ./src/components/modules/Icons/insta.js